import { type UseActionBarProps, useActionBar } from "./useActionBar";

type UseHideActionBar = Pick<
  UseActionBarProps,
  "dependencies" | "retentionSite"
>;

export const useHideActionBar = ({
  dependencies = [],
  retentionSite = []
}: UseHideActionBar = {}) => {
  useActionBar({ visible: false, retentionSite, dependencies });
};
